import React, { useContext, useEffect, useState } from 'react';
import { getUnreadNotificationsCount } from 'features/notifications/ducks/notificationsActions';
import { Link } from 'react-router-dom';
import { AuthContext } from 'features/auth/context/Auth';
import { connect } from 'react-redux';
import logo from 'assets/img/hybrid-white.png';
import Dropdown from 'react-bootstrap/Dropdown';
import { logout } from 'features/auth/ducks/authActions';
import './Header.scss';

const Header = props => {
  const {
    activeItem,
    logout,
    trainer,
    unreadChannels,
    unreadNotificationsCount,
    getUnreadNotificationsCount
  } = props;
  const currentUser = useContext(AuthContext).currentUser;
  const isSignedIn = currentUser ? true : false;

  const [firstLetters, setFirstLetters] = useState('');

  useEffect(() => {
    // this code for the old accounts that already logged in
    currentUser && !currentUser.emailVerified && logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  useEffect(() => {
    isSignedIn &&
      trainer.first_name &&
      setFirstLetters(
        `${trainer.first_name[0].toUpperCase()}${trainer.last_name[0].toUpperCase()}`
      );

    trainer?.id &&
      getUnreadNotificationsCount(
        trainer.id,
        trainer.last_read_notification_date || trainer.created_at
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, trainer]);

  if (
    window.location.pathname.startsWith('/auth/action') ||
    window.location.pathname === '/onboarding'
  ) {
    return null;
  }

  return (
    <header id="header" className="header">
      <div className="container">
        <div className="header-wrapper">
          <div className="logo">
            <h1>
              <Link to="/">
                <img src={logo} alt="Hybrid Logo" />
              </Link>
            </h1>
          </div>
          {isSignedIn && currentUser.emailVerified && (
            <div className="main-nav">
              <ul>
                <li>
                  <Link
                    to="/"
                    className={`${activeItem === 'home' ? 'active' : ''}`}
                  >
                    <i className="fas fa-calendar-day"></i> <span>Home</span>
                  </Link>
                </li>
                <li className="messages-link">
                  <Link
                    to="/messages"
                    className={`${activeItem === 'messages' ? 'active' : ''}`}
                  >
                    <i className="fas fa-comment-dots"></i>{' '}
                    <span>Messages</span>
                    {unreadChannels && unreadChannels.size > 0 && (
                      <div className="unread">{unreadChannels.size}</div>
                    )}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/nutrition"
                    className={`${activeItem === 'nutrition' ? 'active' : ''}`}
                  >
                    <i className="fas fa-carrot"></i> <span>Nutrition</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/workouts"
                    className={`${activeItem === 'workouts' ? 'active' : ''}`}
                  >
                    <i className="fas fa-dumbbell"></i> <span>Workouts</span>
                  </Link>
                </li>
                <li className="messages-link">
                  <Link
                    to="/notifications"
                    className={`${
                      activeItem === 'notifications' ? 'active' : ''
                    }`}
                  >
                    <i className="fas fa-bell"></i> <span>Notifications</span>
                    {unreadNotificationsCount > 0 && (
                      <div className="unread">{unreadNotificationsCount}</div>
                    )}
                  </Link>
                </li>
              </ul>
              <div className="user-menu">
                <Dropdown>
                  <Dropdown.Toggle>
                    {trainer.photo ? (
                      <img
                        src={trainer.photo}
                        width="40"
                        height="40"
                        alt={trainer.first_name}
                      />
                    ) : (
                      <i>{firstLetters}</i>
                    )}
                    {/* <img src={avatar} width="40" height="40" /> */}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                    <Dropdown.Item href="/settings">Settings</Dropdown.Item>
                    <Dropdown.Item href="/login" onClick={logout}>
                      Log Out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    unreadChannels: state.messagesReducer.unreadChannels,
    unreadNotificationsCount: state.notificationsReducer.unreadCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
    getUnreadNotificationsCount: (trainerId, lastReadDate) =>
      dispatch(getUnreadNotificationsCount(trainerId, lastReadDate))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
